/**
 * Edit finite-state machine — TD-001 §4.7.3 / PRD-C TR5.
 *
 * Models the lifecycle of in-place text/content editing on the whiteboard:
 * idle → (sticky-edit | rich-edit | plain-edit) → (commit | cancel) → idle.
 * Wiring into the editor controllers follows in a later phase; this file ships
 * only the state machine and its transition table for unit-level verification.
 */
export type EditState = 'idle' | 'sticky-edit' | 'rich-edit' | 'plain-edit';

export type EditEvent = 'enter-sticky' | 'enter-rich' | 'enter-plain' | 'commit' | 'cancel';

export const EDIT_TRANSITIONS = {
  idle: {
    'enter-sticky': 'sticky-edit',
    'enter-rich': 'rich-edit',
    'enter-plain': 'plain-edit',
  },
  'sticky-edit': { commit: 'idle', cancel: 'idle' },
  'rich-edit': { commit: 'idle', cancel: 'idle' },
  'plain-edit': { commit: 'idle', cancel: 'idle' },
} as const satisfies Readonly<Record<EditState, Partial<Record<EditEvent, EditState>>>>;
